import {DeleteOutlined} from "@ant-design/icons";

export const TrashWidget = ({onDelete, props}) => {
    const divStyle = {
        cursor: 'pointer'
    }
    return <div style={divStyle} onClick={onDelete}>
        <DeleteOutlined />
    </div>
}